module.exports = __webpack_public_path__ + "static/media/plus.df125d84.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/plus.svg
// module id = 1148
// module chunks = 1